const useRolePermissionTableColumns = apiRef => {
  const columnsData = [
    // {
    //   field: 'name',
    //   headerName: 'عنوان',
    //   flex: 1,
    //   minWidth: 250,
    //   resizable: true,
    //   editable: false,
    //   renderCell: params => {
    //     apiRef.current = params.api;
    //     return params.row.name;
    //   },
    // },
    {
      field: 'display',
      headerName: 'عنوان',
      flex: 1,
      minWidth: 250,
      resizable: true,
      editable: false,
      renderCell: params => {
        apiRef.current = params.api;
        return params.row.display;
      },
    },
  ];

  return [columnsData];
};

export default useRolePermissionTableColumns;
